import { pickBy } from '@/utils'
import AttrItem from './attr-item'

export default {
  name: 'awootag',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '標題' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '副標題' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    { label: 'awoo標簽背景顏色', key: 'bgcolor', component: 'color', value: '#ffffff' },
    { label: '字型顏色', key: 'fontcolor', component: 'color', value: '#000000' },
    {
      label: '',
      key: 'data',
      component: function (h, { key }) {
        return ''
      },
      value: [
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        },
        {
          id: '',
          topic: 'awoo話題'
        }
      ]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          bgcolor: 'bgcolor',
          fontcolor: 'fontcolor'
        })
      },
      data: 'data'
    })
  }
}
